import { Offer } from '../../../schema';
import { uuid } from '../../../utils';
var BasketItem = /*@__PURE__*/ (function () {
    function BasketItem(data) {
        if (data) {
            this.time = data.time;
            this.id = data.id;
            this.offer = new Offer();
            this.offer.loadJSON(data.offer);
            this.amount = data.amount;
        }
        else {
            this.time = new Date();
            this.id = uuid();
            this.amount = 1;
        }
    }
    return BasketItem;
}());
export { BasketItem };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/basket/schema/basket-item.ts
// module id = null
// module chunks = 